<app-modal
  [title]="'Product selection in package'| trans:'kiosk/package-selection-modal/title.Text'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-container modal-precontent>
    <div class="d-flex align-items-center justify-content-center gap-8 p1 m-y-8">
      <p>
        <b>{{ 'Package name:'| trans:'kiosk/package-selection-modal/package-name.Label' }}</b>
      </p>
      <p>
        {{ data?.displayName }}
      </p>
    </div>
  </ng-container>

  <ng-template>
    <div class="d-flex gap-16 flex-grow-1 flex-direction-column align-items-center">
      <div class="d-flex gap-32 align-items-start flex-wrap">
        @for (group of groups; track group.groupingNr) {
          <div min-width="242px" max-width="242px" class="c-bg-gray-200 p-8 base-border-radius">
            <h5 class="text-uppercase">
              @if (group.groupingNr !== undefined) {
                {{ 'Group'| trans:'kiosk/package-selection-modal/group.Label' }} {{ group.groupingNr }}:
              } @else {
                {{ 'Im Paket enthalten'| trans:'kiosk/package-selection-modal/includedInPackage.Label' }}
              }
            </h5>
            <div class="d-flex m-t-8 d-flex flex-direction-column gap-8">
              @for (option of group.options; track option.id) {
                <div
                  class="p-8 d-flex align-items-center gap-16 base-border-radius product position-relative cursor-pointer"
                  (click)="option.contentPackage || group.groupingNr !== undefined ? selectOption(group, option) : null"
                  [class.selected]="option.selected"
                >
                  @if (option.selected) {
                    <i class="ri-checkbox-circle-line c-t-ok-500 position-absolute icon-xs"></i>
                  }

                  @if (option.bitmapUrl) {
                    <img
                      [src]="environment.apiUrl + option.bitmapUrl"
                      [alt]="option.name"
                      width="40"
                      height="40"
                      class="object-fit-contain"
                      appImgFallback
                      type="product"
                    >
                  }

                  <p class="p2">{{ option.name }}</p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="cancelSelection()"
      >
        {{ 'Cancel'| trans:'kiosk/package-selection-modal/cancel.Button' }}
      </button>
      <button
        #btn
        class="button button--md button--primary text-uppercase"
        [disabled]="isConfirmButtonDisabled"
        (click)="confirmPackage(btn)"
      >
        {{ 'Confirm'| trans:'kiosk/package-selection-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
